import { getT } from '@/i18n';
/**
 * A natív Google SDK angol hibaüzeneteiből magyar mondat.
 *
 * A natív réteg (`@capacitor-firebase/authentication`) a Google Sign-In / One
 * Tap nyers hibáját adja tovább, például:
 * `During being sign in, failure response from one tap:10: [28444] Developer
 * console is not set up correctly`. Ezt a felhasználó nem tudja értelmezni.
 *
 * A `10` (DEVELOPER_ERROR) az egyetlen eset, ami nem a felhasználón múlik:
 * ilyenkor a futó app csomagneve és aláíró SHA-1 ujjlenyomata nincs felvéve a
 * Firebase Android OAuth kliensébe (lásd `docs/08-android-codemagic.md`,
 * „Mért hibaminta: one tap:10").
 *
 * @returns a megjelenítendő magyar mondat, vagy `null`, ha nem ismerjük fel a
 *   hibát — ilyenkor a hívó az eredeti hibát dobja tovább.
 */
export function nativeGoogleErrorMessage(message: string): string | null {
  if (/developer console|developer_error/i.test(message)) {
    return (
      getT().googleAuthErrors.configuration
    );
  }
  if (/no credential|credential.*not available/i.test(message)) {
    return (
      getT().googleAuthErrors.noAccount
    );
  }
  if (/network|timeout|timed out/i.test(message)) {
    return getT().googleAuthErrors.network;
  }
  return null;
}
